module.exports = __webpack_public_path__ + "img/lobby-default-bg.173d7466.png";